import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ICreditLimitRequestsResponse } from "../../types/api/creditLimitRequestsApi";
import {
  getCreditLimitRequestDetailService,
  getCreditLimitRequestsDataService,
  updateCreditLimitStatusQuery,
} from "../../api/creditLimitRequestsApi";
import { CreditLimitRequestsState } from "../../types/features/creditLimitRequestsSlice";
import { ITableRequestData } from "../../types/common";

export const getCreditLimitRequestsData = createAsyncThunk<
  ICreditLimitRequestsResponse,
  ITableRequestData
>("creditLimitRequests/getCreditLimitRequestsData", async ({ limit, page }) => {
  const response = await getCreditLimitRequestsDataService({ limit, page });
  return response.data;
});

export const getCreditLimitRequestDetail = createAsyncThunk<
  ICreditLimitRequestsResponse,
  { id: string }
>("creditLimitRequests/getCreditLimitRequestDetail", async ({ id }) => {
  // // // console.log("redux :: ", { id });

  const response = await getCreditLimitRequestDetailService({ id });
  return response.data;
});

export const changeCreditLimitStatus = createAsyncThunk<
  ICreditLimitRequestsResponse,
  { id: string; status: string }
>("creditLimitRequests/changeCreditLimitStatus", async ({ id, status }) => {
  const response = await updateCreditLimitStatusQuery(id, status);
  return response.data;
});

const CreditLimitRequestsSlice = createSlice({
  name: "CreditLimitRequests",
  initialState: {
    creditLimitRequestsLoader: false,
    status: false,
    msg: "",
    data: [],
    total: 0,
    detail: {},
  } as CreditLimitRequestsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCreditLimitRequestsData.pending, (state) => {
        state.creditLimitRequestsLoader = true;
      })
      .addCase(getCreditLimitRequestsData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.total = action.payload.pagination.total;
        state.msg = action.payload.message;
        state.status = true;
        state.creditLimitRequestsLoader = false;
      })
      .addCase(getCreditLimitRequestsData.rejected, (state, action) => {
        state.creditLimitRequestsLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(getCreditLimitRequestDetail.pending, (state) => {
        state.creditLimitRequestsLoader = true;
      })
      .addCase(getCreditLimitRequestDetail.fulfilled, (state, action) => {
        state.detail = action.payload.data;
        state.msg = action.payload.message;
        state.status = true;
        state.creditLimitRequestsLoader = false;
      })
      .addCase(getCreditLimitRequestDetail.rejected, (state, action) => {
        state.creditLimitRequestsLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(changeCreditLimitStatus.pending, (state) => {
        state.creditLimitRequestsLoader = true;
      })
      .addCase(changeCreditLimitStatus.fulfilled, (state, action: any) => {
          state.data.map((item: any) => {
              if (item._id === action.payload.data._id) {
                  item.status = action.payload.data.status;
                  return item;
              }else{
                return item;
              }
          });
          state.msg = action.payload.message;
          state.status = true;
          state.creditLimitRequestsLoader = false;
      })
      .addCase(changeCreditLimitStatus.rejected, (state, action) => {
        state.creditLimitRequestsLoader = false;
        state.status = false;
        state.msg = action.error.message;
      });
  },
});

export default CreditLimitRequestsSlice.reducer;
